import { AbstractContainer } from '../operator/AbstractContainer';
import { RecShapeIfc } from '../../shape/RecShapeIfc';
import { SetListenerIfc } from '../SetListenerIfc';

export class ConcreteContainer extends AbstractContainer {
    shape:RecShapeIfc;
		
		
    constructor( shape:RecShapeIfc ) 
    {
        super();
        this.shape = shape;
    }

    public getShape():RecShapeIfc {
        return this.shape;
    }
    public addListener(listener:SetListenerIfc):void {

    }
    public removeListener( listener:SetListenerIfc):void {
    }
}